import { Navigate, useLocation } from "react-router-dom";
import { firstAdminPath } from "../../config/navigation";
import { useAuth } from "../../stores/auth";

export function AdminIndexRedirect() {
  const { can } = useAuth();
  const path = firstAdminPath(can);
  if (!path) return <Navigate to="/" replace />;
  return <Navigate to={path} replace />;
}

export function LegacyAdminRedirect({ to }: { to: string }) {
  return <Navigate to={to} replace />;
}

/** Maps legacy `/admin/cms/*` URLs to `/content/*` (hero → slider). */
export function LegacyCmsRedirect() {
  const { pathname, search } = useLocation();
  let next = pathname.replace(/^\/admin\/cms\/hero\/?$/, "/content/slider");
  if (next === pathname) {
    next = pathname.replace(/^\/admin\/cms\/?$/, "/content/pages");
  }
  if (next === pathname) {
    next = pathname.replace(/^\/admin\/cms/, "/content");
  }
  return <Navigate to={`${next}${search}`} replace />;
}
